import { Vehicle } from '../types/trip.type';
import { LocalVehicle, VehicleModalOptions, StateVehicleType } from '../components';
import states from '../assets/states.json';
import _ from 'lodash';

export class VehicleUtils {
    public static mapToTripVehicles = (newVehicles: LocalVehicle[]) => {
        const mappedVehicles: Vehicle[] = newVehicles.map((v) => {
            return {
                type: 'reservation-vehicle',
                attributes: {
                    license_state: v.stateCode === StateVehicleType.OTHER ? v.otherState : v.stateCode,
                    license_number: v.plate,
                },
            };
        });

        return mappedVehicles;
    };

    public static mapToLocalVehicles = (vehicles: any[]) => {
        return vehicles.map((vehicle) => {
            const state = states.find((s) => s.state === vehicle.license_state);
            return {
                id: vehicle.registration_id,
                stateCode: state ? vehicle.license_state : StateVehicleType.OTHER,
                stateName: state ? state.stateName : vehicle.license_state,
                plate: vehicle.license_number,
                otherState: state ? '' : vehicle.license_state,
            };
        });
    };

    public static getStateNameByCode = (code: string, otherState?: string) => {
        if (code === StateVehicleType.OTHER && otherState) {
            return otherState;
        }

        const state = states.find((s) => s.state === code);
        return state ? state.stateName : '';
    };

    public static updateLocalVehicleList = (vehicles: any, currentVehicle: any, vehicleModalOption: any) => {
        const newVehicles = _.cloneDeep(vehicles);
        switch (vehicleModalOption) {
            case VehicleModalOptions.ADD:
                currentVehicle.stateName = VehicleUtils.getStateNameByCode(currentVehicle.stateCode, currentVehicle.otherState);
                newVehicles.push(currentVehicle);
                break;

            case VehicleModalOptions.EDIT:
                const updatedVehicle = newVehicles.find((v: any) => v.id === currentVehicle.id);
                if (updatedVehicle) {
                    updatedVehicle.plate = currentVehicle.plate;
                    updatedVehicle.stateCode = currentVehicle.stateCode;
                    updatedVehicle.stateName = VehicleUtils.getStateNameByCode(currentVehicle.stateCode, currentVehicle.otherState);
                    updatedVehicle.otherState = currentVehicle.otherState;
                }
                break;

            case VehicleModalOptions.REMOVE:
                newVehicles.splice(vehicles.indexOf(currentVehicle), 1);
                break;
        }

        return newVehicles;
    };

    public static formatPlate = (variable: string) => {
        return variable
            .replace(/[<>¿¡]+/g, '')
            .toUpperCase()
            .substr(0, 12);
    };

    public static formatOtherState = (variable: string) => {
        return variable.substr(0, 16);
    };
}
